import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit'
import { TUserProfile } from '@smartico/public-api/dist/WSAPI/WSAPITypes'
import { Smartico } from '../../core/Smartico'
import { RootState } from '../store'

export enum LoginStatus {
    NotLoggedIn,
    LoggedIn,
}

interface UserState {
    loggedIn: LoginStatus
    profile: TUserProfile | null
    error: string | null
}

const initialState: UserState = {
    loggedIn: LoginStatus.NotLoggedIn,
    profile: null,
    error: null,
}

export const fetchUserProfile = createAsyncThunk('user/fetchUserProfile', async (_, { rejectWithValue, dispatch }) => {
    try {
        const fetchProfile = async () => {
            const smarticoApi = await Smartico.apiReady
            const response = await smarticoApi.getUserProfile()
            if (response) {
                dispatch(setUserProfile(response));
            }
            return response;
        }
    
        const intervalId = setInterval(async () => {
            const smarticoLib = Smartico.lib()
    
            if (smarticoLib) {
                const res = await fetchProfile();

                if (res.ach_level_current_id) {
                    clearInterval(intervalId)
                }
            }
        }, 1000)
    } catch (error) {
        return rejectWithValue('Failed to fetch user profile')
    }
})

export const subscribeToProfileChanges = () => async (dispatch: any) => {
    const handlePropsChange = async () => {
        dispatch(fetchUserProfile())
    }

    const t = setInterval(() => {
        const smarticoLib = Smartico.lib();

        if (smarticoLib) {
            smarticoLib.on('props_change', handlePropsChange);
            clearInterval(t);
        }
    }, 1000);
}

const userPublicSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        setLoginStatus(state, action: PayloadAction<LoginStatus>) {
            state.loggedIn = action.payload
        },
        setUserProfile(state, action: PayloadAction<TUserProfile>) {
            state.profile = action.payload
            state.loggedIn = LoginStatus.LoggedIn
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchUserProfile.pending, (state) => {
                // state.profile = null
                // state.error = null
            })
            .addCase(fetchUserProfile.fulfilled, (state, action) => {
                // state.profile = action.payload
                state.loggedIn = LoginStatus.LoggedIn
                state.error = null
            })
            .addCase(fetchUserProfile.rejected, (state, action) => {
                state.profile = null
                state.error = action.payload as string
            })
    },
})

export const { setLoginStatus, setUserProfile } = userPublicSlice.actions

export default userPublicSlice.reducer

// Selector to get the user profile from the store
export const selectUserProfile = (state: RootState) => state.user.user?.profile